import { NgModule } from '@angular/core'
import { RouterModule } from '@angular/router'
import { TabsSearchSetComponent } from './tabs-search-set.component'
import { SharedModule } from 'src/app/shared/shared.module'
import { TabsModule } from '../tabs/tabs.module'

@NgModule({
  imports: [RouterModule, SharedModule, TabsModule],
  exports: [TabsSearchSetComponent],
  declarations: [TabsSearchSetComponent]
})
export class TabsSearchSetModule {}
